import { compose } from 'recompose'
import { defineMessages } from 'react-intl'
import { withPurchasePowerProps } from '../../../features/homeowners/composables/withMinimumEquityAndGemDisplayProps'
import { ModuleShown, EVENTS_LABELS } from '../../../constants/trackingEvents'
import withEventOnceOnMount from '../../../composables/withEventOnceOnMount'
import { PurchasingPowerPanel } from '../../../constants/notificationRefs'

import gems from './gems'

const defaultDM = defineMessages({
  question: {
    id: 'Homeowner.purchasePower.defaultQuestion',
    defaultMessage: 'What option is best for me?',
  },
  topic: {
    id: 'Homeowner.purchasePower.defaultTopic',
    defaultMessage: 'using their purchasing power',
  },
})

const PurchasingPowerContainer = compose(
  withPurchasePowerProps({
    gems,
    defaultDM,
    cardRef: PurchasingPowerPanel,
    padding: 50,
  }),
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.PurchasingPowerModule,
  })
)

export default PurchasingPowerContainer
